<template>
  <el-form ref="form">
    <div class="table-contract-container">
      <el-row>
        <el-col :span="6" class="filter-input">
          <el-input :placeholder="$t('keyword')"
                    @input="isSearching = true"
                    v-model="keyword"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" v-loading="isSearching">
          <div class="contract-table contract-table-head">
            <ul>
              <li style="width: 5%"></li>
              <li style="width: 10%">{{$t('code')}}</li>
              <li style="width: 50%">{{$t('detail')}}</li>
              <li style="width: 25%; text-align: center">{{$t('periodOfStay')}}</li>
              <li style="width: 10%; text-align: center">{{$t('night')}}</li>
            </ul>
          </div>
          <div v-for="(promotion, index) of promotionTableDataList" :key="`promotion-${index}`">
            <div class="contract-table" v-show="promotion.isShow">
              <ul>
                <li style="width: 5%; text-align: center"><el-checkbox v-model="promotionCheckList[index].isCheck" @change="onSelectedPromotionChange"></el-checkbox></li>
                <li style="width: 10%;word-wrap: break-word;">{{promotion.code}}</li>
                <li style="width: 50%;word-wrap: break-word;">{{promotion.detail}}</li>
                <li style="width: 25%; text-align: center">
                  <span v-if="promotion.periodOfStayList.length === 0">-</span>
                  <div v-for="(periodOfStay, index) of promotion.periodOfStayList" :key="`period-${index}`">
                    <span>{{bindPeriodOfStay(periodOfStay.startDate, periodOfStay.endDate)}}</span>
                  </div>
                </li>
                <li style="width: 10%; text-align: center">
                  <div>Min: {{promotion.minNight}}</div>
                  <div>Max: {{promotion.maxNight}}</div>
                </li>
              </ul>
              <div class="contract-data-version" v-if="isUpdatedData(promotionList, promotion)">
                <div class="contract-data-updated">
                  <div style="padding: 20px 0 0 20px">
                    <strong>*{{$t('updatedPromotionMessage')}}</strong>
                  </div>
                  <el-radio-group style="padding-left: 40px" v-model="promotionCheckList[index].version" fill="#ff0000" @change="onSelectedPromotionChange()">
                    <div class="contract-data-version-radio">
                      <el-radio :label="DATA_VERSION.SELECTED">{{$t('selectedVersion')}} ({{bindUpdatedAt(promotion.updatedAt)}})</el-radio>
                    </div>
                    <div class="contract-data-version-radio">
                      <el-radio :label="DATA_VERSION.LATEST">{{$t('latestVersion')}} ({{bindLatestUpdatedAt(promotion.id)}})</el-radio>
                    </div>
                  </el-radio-group>
                </div>
              </div>
              <div class="contract-data-version" v-if="isDeletedData(promotionList, promotion.id)">
                <div class="contract-data-deleted">
                  <div style="padding: 20px 0 0 20px">
                    <strong style="color: #dd3333">*{{$t('deletedPromotionMessage')}}</strong>
                  </div>
                  <el-radio-group style="padding-left: 40px" v-model="promotion.id" fill="#ff0000" >
                    <el-radio :label="promotion.id" class="contract-data-version-radio">{{$t('selectedVersion')}} ({{bindUpdatedAt(promotion.updatedAt)}})</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <remark-component
      :remark-type="REMARK_TYPE.PROMOTION"
      :remark-list="defaultRemarkList"
      :contract-detail="contractDetail"
      @onRemarkChange="onRemarkChange">
    </remark-component>
  </el-form>
</template>

<script>
import i18nMessages from '@/translations/Contract/components/TabContractPromotion.i18n'
import RemarkComponent from '@/views/Contract/components/RemarkComponent'
import { filterDataByKeyword } from '@/services/general-service'
import { getTableDataSource } from '@/services/contract-service'
import { get, debounce } from 'lodash'
import { REMARK_TYPE } from '@/configs/constant'
import { applyNewRemark } from '@/domains/contract-domain'
import { dateFormat } from '@/helpers/datetime'
import {
  isUpdatedData,
  isDeletedData,
  DATA_VERSION,
  getSelectedDataListByVersion,
  getDataCheckList
} from '@/services/version-service'

export default {
  name: 'TabPromotionComponent',
  i18n: { messages: i18nMessages },
  components: { RemarkComponent },
  model: {
    prop: 'contractDetail',
    event: 'onPromotionDetailChange'
  },
  props: {
    promotionList: {
      type: Array,
      default: function () {
        return []
      }
    },
    defaultRemarkList: {
      type: Array,
      default: function () {
        return []
      }
    },
    contractDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  watch: {
    keyword: debounce(function () {
      this.isSearching = false
    }, 300),
    isSearching: function (value) {
      if (!value) {
        this._filterPromotionListDataSource()
      }
    }
  },
  data () {
    return {
      REMARK_TYPE,
      DATA_VERSION,
      isUpdatedData,
      isDeletedData,
      promotionTableDataList: [],
      promotionCheckList: [],
      newRemark: {},
      contractPromotionRemarkTmp: '',
      keyword: '',
      isSearching: false
    }
  },
  created: function () {
    this._getPromotionListDataSource()

    const promotionList = get(this.contractDetail, 'promotionList', [])
    this.promotionCheckList = getDataCheckList(this.promotionTableDataList, promotionList)
  },
  methods: {
    bindPeriodOfStay: function (startDate, endDate) {
      const fromDate = new Date(startDate)
      const toDate = new Date(endDate)

      return `${dateFormat.short(fromDate)} - ${dateFormat.short(toDate)}`
    },
    bindLatestUpdatedAt: function (contractPromotionId) {
      const promotion = this.promotionList.find(item => item.id === contractPromotionId)

      if (promotion !== undefined) {
        const date = new Date(promotion.updatedAt)
        return dateFormat.long(date)
      }
    },
    bindUpdatedAt: function (updatedDate) {
      const date = new Date(updatedDate)
      return dateFormat.long(date)
    },
    onRemarkChange: function (newRemark) {
      this.newRemark = newRemark

      this.onSelectedPromotionChange()
    },
    onSelectedPromotionChange () {
      const remarkList = applyNewRemark(this.contractDetail, this.newRemark)
      const result = getSelectedDataListByVersion(
        this.promotionCheckList,
        this.promotionTableDataList,
        this.promotionList
      )
      const promotionList = {
        promotionList: result
      }

      const newRemarkList = {
        remarkList: remarkList
      }

      const contractDetail = Object.assign({}, this.contractDetail, promotionList, newRemarkList)
      this.$emit('onPromotionDetailChange', contractDetail)
    },
    _getPromotionListDataSource: function () {
      const promotionList = get(this.contractDetail, 'promotionList', [])
      this.promotionTableDataList = getTableDataSource(this.promotionList, promotionList)
      this.promotionTableDataList.sort((a, b) => (a.code > b.code) ? 1 : -1)

      this._prepareFilter()
    },
    _prepareFilter: function () {
      this.promotionTableDataList = this.promotionTableDataList.map((promotion) => {
        promotion.isShow = true
        return promotion
      })
    },
    _filterPromotionListDataSource: function () {
      const searchKeys = ['code', 'detail']
      const filteredPromotionDataList = filterDataByKeyword(this.promotionTableDataList, this.keyword, searchKeys)

      this.promotionTableDataList = this.promotionTableDataList.map((promotion) => {
        const filteredPromotion = filteredPromotionDataList.find(item => item.id === promotion.id)
        promotion.isShow = (filteredPromotion !== undefined)

        return promotion
      })
    }
  }
}
</script>

<style scoped>
  .table-contract-container {
    margin: 0 30px;
    box-shadow: #d4d4d4 0 0 5px;
    border: 1px solid #dddddd;
    border-radius: 5px;
  }
  .filter-input {
    left: 5%;
    position: relative;
    padding: 10px 0;
  }
</style>
